module.exports = __webpack_public_path__ + "img/conception.4864174e.png";